/**
 * Created by dmitry on 27.01.2026
 */

cleverapps.User.prototype.spendHard = cleverapps.extendFunc(cleverapps.User.prototype.spendHard, function (eventName, value, silent) {
    if (this.canTakeHard(value) && !silent) {
        cleverapps.effects.fire("ui.spend.hard");
    }
    return this._super(eventName, value, silent);
});

cleverapps.User.prototype.spendSoft = cleverapps.extendFunc(cleverapps.User.prototype.spendSoft, function (eventName, soft, options) {
    if (this.canTakeSoft(soft)) {
        cleverapps.effects.fire("ui.spend.soft");
    }
    return this._super(eventName, soft, options);
});